import { createContext, useContext, useMemo, useState } from "react";
import { TRANSLATIONS } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("konek_lang");
    return TRANSLATIONS[saved] ? saved : "en";
  });
  const setLang = (l) => {
    if (!TRANSLATIONS[l]) return;
    localStorage.setItem("konek_lang", l);
    setLangState(l);
  };
  const value = useMemo(() => ({ lang, setLang, t: TRANSLATIONS[lang] }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
